__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.52.0-e225-amber-user-website-prod-hk-1818/assets/";